import styled from "styled-components";
const PaySlipSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;

  .headings {
    display: flex;
    flex-direction: column;
  }
  .summary {
    display: flex;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .employee-personal {
    display: flex;
    gap: 2rem;
    /* justify-content: space-between; */
  }
  .account-details {
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
  }
  .employee-particulars {
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
  }
  .employee-leave-details {
    display: flex;
  }
  .employee-leave-history {
    display: flex;
    gap: 5px;
  }
  .employee-pay-details {
    padding: 1rem;
    display: flex;
    gap: 2rem;
  }
  .employee-pay-details > div {
    padding: 3px;
  }
  .earnings-title {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .earnings-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .deductions-details-main {
    display: flex;
    gap: 2rem;
    padding: 1rem;
  }
  .earnings-container {
    display: flex;
    gap: 2.5rem;
  }
  .tax-details {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .tax-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .net-pay {
    display: flex;
    justify-content: end;
  }
  .employee-additional-details {
    display: flex;
    gap: 10px;
  }
  .org-employee-details {
    display: flex;
    gap: 5rem;
  }
  .employee-details1 {
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
  }
  .employee-details2 {
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
  }
  .payslip-leave-detail {
    margin: 0;
  }
  .payslip-leave-details {
    margin: 0;
    width: 45%;
  }
  th {
    background-color: #e0e0e0;
    border: 1px solid #4285f4;
    color: #000;
    padding: 8px;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-width: 5px;
    border: 1px solid black;
  }
  td {
    text-align: left;
    border: 1px solid black;
  }
  .net-pay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: dotted;
    margin: 20px auto;
    padding: 1rem;
    width: 80%;
  }
`;
export default PaySlipSc;
